export default "__VITE_ASSET__4a0e56d5__"